import { MessageCircle, Instagram } from "lucide-react";
import { Logo } from "./Logo";
import { waLink, INSTAGRAM_URL, WHATSAPP_NUMBER_DISPLAY } from "./constants";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-[#021A23]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-3 gap-12">
          <div>
            <Logo />
            <p className="mt-5 text-sm text-slate-500 leading-relaxed max-w-xs">
              Independent mortgage advice from me, Kieran — honest, personal
              and always in plain English.
            </p>
          </div>
          <div>
            <p className="font-mono text-[11px] tracking-[0.25em] uppercase text-slate-500 mb-5">
              Talk to Me
            </p>
            <div className="space-y-3">
              <a
                href={waLink("Hi Kieran, I'd like some mortgage advice.")}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp-link"
                className="flex items-center gap-2.5 text-sm text-slate-300 hover:text-[#25D366] transition-colors"
              >
                <MessageCircle size={16} className="text-[#25D366]" />
                WhatsApp {WHATSAPP_NUMBER_DISPLAY}
              </a>
              <a
                href={INSTAGRAM_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram-link"
                className="flex items-center gap-2.5 text-sm text-slate-300 hover:text-amber-300 transition-colors"
              >
                <Instagram size={16} className="text-amber-400" />
                @kieranwoolleymortgages
              </a>
            </div>
          </div>
          <div>
            <p className="font-mono text-[11px] tracking-[0.25em] uppercase text-slate-500 mb-5">
              The Important Bit
            </p>
            <p className="text-xs text-slate-500 leading-relaxed">
              Your home may be repossessed if you do not keep up repayments on
              your mortgage. Any advice I give depends on your circumstances
              and lender criteria.
            </p>
            <p className="mt-4 text-xs text-slate-500 leading-relaxed">
              Kieran Woolley T/A KW Mortgages is an Appointed Representative of
              Stonebridge Mortgage Solutions Ltd, which is authorised and
              regulated by the Financial Conduct Authority.
            </p>
            <p className="mt-4 font-mono text-[11px] tracking-wider text-slate-400">
              FCA Firm Reference Number: 1033199
            </p>
          </div>
        </div>
        <div className="mt-14 pt-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-600">
            © {new Date().getFullYear()} KW Mortgages. All rights reserved.
          </p>
          <p className="font-mono text-[11px] tracking-[0.25em] uppercase text-slate-600">
            Whole-of-Market · Independent · Personal
          </p>
        </div>
      </div>
    </footer>
  );
}
